
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!


export class GenStateReliability {

    id: number;
    caidiMeds: number;
    caidiNoMeds: number;
    collectionMethod: string;
    dataYear: number;
    saidiMeds: number;
    saidiNoMeds: number;
    saifiMeds: number;
    saifiNoMeds: number;
    stateId: number;
    stateName: string;

    constructor();
    constructor( jsonObj: any );
    constructor( genStateReliability: GenStateReliability);
    constructor( id: number );

    constructor( input?: GenStateReliability|number ) {
        if ( typeof input === 'number') {
            this.id = input;
        }

        if ( input && typeof input !== 'number' ) {
            this.id = input.id; // int [number]
            this.caidiMeds = input.caidiMeds; // float [number]
            this.caidiNoMeds = input.caidiNoMeds; // float [number]
            this.collectionMethod = input.collectionMethod; // string [string]
            this.dataYear = input.dataYear; // int [number]
            this.saidiMeds = input.saidiMeds; // float [number]
            this.saidiNoMeds = input.saidiNoMeds; // float [number]
            this.saifiMeds = input.saifiMeds; // float [number]
            this.saifiNoMeds = input.saifiNoMeds; // float [number]
            this.stateId = input.stateId; // int [number]
            this.stateName = input.stateName; // string [string]
       }
    }

    static jsonResponseToList(arr: any[]): GenStateReliability[] {
        if (arr && arr.map) {
          return arr.map(a => new GenStateReliability(a));
        } else {
          return [];
        }
    }
}

